<template>
    <default-layout />
</template>

<script setup>

import { ref, provide, onMounted } from "vue";

import DefaultLayout from "@/layouts/default/DefaultLayout.vue"
import { watch } from 'vue'
import { useTimedReload } from "@/service/timedReload"
import { useI18n } from "vue-i18n";

import { useRuntimeStore } from "@/store/runtime"
import { useSharedStore } from "@/store/shared"


import { useApi } from "@/service/api";
const api = useApi()



const { locale } = useI18n({});


const timedReload = useTimedReload()

timedReload.activate()


const runtimeStore = useRuntimeStore()
runtimeStore.loadSession(locale)

const sharedStore = useSharedStore()
sharedStore.init()



const windowWidth = ref(window.innerWidth);
const windowHeight = ref(window.innerHeight);



provide('windowSize', { width: windowWidth, height: windowHeight })

const updateWidthAndHeight = () => {
  windowWidth.value = window.innerWidth;
  windowHeight.value = window.innerHeight;
  // console.log("windowWidth", windowWidth.value)
};

onMounted(() => {
  window.addEventListener('resize', updateWidthAndHeight);
});


onMounted(async () => {
  // serviceApi.serviceGetACsrfToken()
  // authStore.init()


  setTimeout(async () => {
    const loadAnnotazioni = await  api.tracker.getAnnotazioni()
    const loadStambecchi = await api.tracker.getStambecchiPreviousMonth()
  }, 500)




})


watch(() => runtimeStore.session.settings?.fontSize, (newValue,oldValue,) => {
  console.log("fontSize", oldValue)
  console.log("fontSize", newValue)

  // get html tag element
 
  const size = 1
  const fontIncrease = runtimeStore.session.settings?.fontSize / 10 || 0
  const result = `${(size + fontIncrease).toFixed(2)}rem`

  document.documentElement.style.fontSize = result

})
// const fs = computed(() => {
//   console.log("fontSize", runtimeStore?.session?.settings?.fontSize)

//   const size = 1
//   const fontIncrease = runtimeStore.session.settings?.fontSize / 10 || 0

//   const result = `${(size + fontIncrease).toFixed(1)}rem`
//   console.log(result)
//   return result
// })



</script>

<style>

/* 
html{
  font-size: v-bind(fs)!important; 
} 
  

or use pseudo :global() 

*/

#app {
  background-color: rgb(33,33,33);

}

body {
  background-color: rgb(33,33,33);
}



/* html {
  overflow-y: auto !important
} */


.fluid-column {
  column-gap: 4em;
  column-width: 32em;
  column-count: auto;
  column-rule: 1px solid #ddd;
  /* column-count: 3; */
  widows: 3;
  orphans: 3;
}

.fluid-column > * {
  break-inside: avoid;
}


.disable-active  :deep(.v-btn__overlay),
.disable-active  :deep(.v-list-item__overlay) {
  opacity: 0!important;
}



.v-list-item--three-line .v-list-item__prepend:has(.prepend_centerer) {
    align-self: center;
}



.v-fab__container{
  position: inherit!important;
}
.v-fab{
  flex: 0!important;
}


</style>
